import { Dialog, DialogContent } from "@/components/ui/dialog";
import { useNavigate } from "react-router-dom";
import { ArrowRight, Briefcase, Building2 } from "lucide-react";
import logoChillwerk from "@/assets/logo-chillwerk.png";


interface StartChoiceDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const StartChoiceDialog = ({ open, onOpenChange }: StartChoiceDialogProps) => {
  const navigate = useNavigate();

  const handleChoice = (type: "candidate" | "company") => {
    onOpenChange(false);
    if (type === "candidate") {
      navigate("/signup/kandidaat");
    } else {
      navigate("/start/bedrijven");
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md w-[calc(100vw-2rem)] min-w-0 rounded-3xl p-0 overflow-hidden max-h-[90vh] overflow-y-auto">
        {/* Header — zelfde stijl als de sollicitatie-keuze */}
        <div className="bg-gradient-to-br from-cyan-light/40 via-secondary/20 to-yellow-100/40 px-6 py-6 text-center">
          <div className="mx-auto mb-3 w-16 h-16 rounded-full bg-white flex items-center justify-center shadow-lg overflow-hidden">
            <img src={logoChillwerk} alt="ChillWerk.nl" className="w-12 h-12 object-contain" />
          </div>
          <h2 className="text-2xl font-heading font-black mb-1">Hoe wil jij starten?</h2>
          <p className="text-sm text-foreground/70">Binnen 1 minuut een account</p>
        </div>

        <div className="px-5 pb-6 pt-5 space-y-3">
          {/* Kandidaat */}
          <button
            type="button"
            onClick={() => handleChoice("candidate")}
            className="group w-full flex items-center gap-4 p-4 text-left rounded-2xl border border-foreground/10 bg-white hover:border-secondary hover:bg-secondary/10 hover:-translate-y-0.5 hover:shadow-lg transition-all duration-200"
          >
            <div className="w-12 h-12 rounded-xl bg-secondary flex items-center justify-center flex-shrink-0 shadow-sm transition-transform duration-200 group-hover:scale-105">
              <Briefcase className="w-5 h-5 text-secondary-foreground" />
            </div>
            <p className="flex-1 min-w-0 font-bold text-base leading-none">Ik zoek werk</p>
            <ArrowRight className="w-5 h-5 text-foreground/40 flex-shrink-0 transition-transform duration-200 group-hover:translate-x-1 group-hover:text-foreground" />
          </button>

          {/* Werkgever */}
          <button
            type="button"
            onClick={() => handleChoice("company")}
            className="group w-full flex items-center gap-4 p-4 text-left rounded-2xl border border-foreground/10 bg-white hover:border-cyan hover:bg-cyan-light/25 hover:-translate-y-0.5 hover:shadow-lg transition-all duration-200"
          >
            <div className="w-12 h-12 rounded-xl bg-cyan-light/60 flex items-center justify-center flex-shrink-0 transition-transform duration-200 group-hover:scale-105">
              <Building2 className="w-5 h-5 text-cyan-dark" />
            </div>
            <p className="flex-1 min-w-0 font-bold text-base leading-none">Ik ben werkgever</p>
            <ArrowRight className="w-5 h-5 text-foreground/40 flex-shrink-0 transition-transform duration-200 group-hover:translate-x-1 group-hover:text-foreground" />
          </button>


          <p className="text-xs text-center text-muted-foreground pt-1">
            Al een account?{" "}
            <button
              onClick={() => {
                onOpenChange(false);
                navigate("/auth");
              }}
              className="text-cyan-dark hover:underline font-medium"
            >
              Log hier in
            </button>
          </p>
        </div>
      </DialogContent>
    </Dialog>
  );
};
